module.exports = __webpack_public_path__ + "img/compact.79a9655d.png";